import type { TModernColors } from '@modern/theme/modern-theme.types';
import { darkColors } from '@modern/theme/themes/colors/dark-theme';

// Blue, its hover and the sync violet mirror src/reseller/sew/theme/dark-theme.ts; the deep shades are Modern's own.
export const sewDarkColors: TModernColors = {
  ...darkColors,
  accent: {
    base: '#3da7e9',
    border: 'rgba(61, 167, 233, 0.32)',
    deep: '#1a6fa8',
    deepHover: '#1c75b3',
    hover: '#6fb8e7',
    tint: 'rgba(61, 167, 233, 0.1)',
    tintStrong: 'rgba(61, 167, 233, 0.16)',
  },
  status: {
    ...darkColors.status,
    sync: {
      base: '#a46bea',
      border: 'rgba(164, 107, 234, 0.3)',
      tint: 'rgba(164, 107, 234, 0.13)',
      tintStrong: 'rgba(164, 107, 234, 0.16)',
    },
  },
};
